import { getTvObject, tv } from '@costar-ui/cosmos';
import popoverOptions from '../../common/popover-options/popover-options.esm.js';

var popoverTvObject = getTvObject(popoverOptions);
var popoverStyles = tv(popoverTvObject);

export { popoverStyles };
//# sourceMappingURL=popover.styles.esm.js.map
